import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7edbb384")

_pushScopeId("data-v-7edbb384")
const _hoisted_1 = { class: "w-full py-2 px-4 h-full bg-gray-lp-1200" }
const _hoisted_2 = { class: "bg-white w-full h-full rounded-xl p-4" }
const _hoisted_3 = {
  key: 1,
  class: "cargo-table"
}
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "flex flex-col items-start" }
const _hoisted_6 = { class: "w-full flex flex-row items-center gap-x-1 break-all text-left" }
const _hoisted_7 = {
  key: 0,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("g", { id: "table-booking_kapal-berhasil" }, [
  /*#__PURE__*/_createVNode("g", { id: "Union" }, [
    /*#__PURE__*/_createVNode("path", {
      d: "M5.8335 6.66699C5.37326 6.66699 5.00016 7.04009 5.00016 7.50033V8.33366C5.00016 8.7939 5.37326 9.16699 5.8335 9.16699H6.66683C7.12707 9.16699 7.50016 8.7939 7.50016 8.33366V7.50033C7.50016 7.04009 7.12707 6.66699 6.66683 6.66699H5.8335Z",
      fill: "#4D4D4D"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M4.16683 2.50033C4.16683 2.04009 3.79373 1.66699 3.3335 1.66699C2.87326 1.66699 2.50016 2.04009 2.50016 2.50033V3.33366C2.50016 3.38076 2.50407 3.42694 2.51158 3.47191C1.53463 3.81186 0.833496 4.74088 0.833496 5.83366V9.16699C0.833496 10.5477 1.95278 11.667 3.3335 11.667H7.50016C8.88088 11.667 10.0002 10.5477 10.0002 9.16699V5.83366C10.0002 4.74088 9.29903 3.81186 8.32208 3.47191C8.32959 3.42694 8.3335 3.38076 8.3335 3.33366V2.50033C8.3335 2.04009 7.9604 1.66699 7.50016 1.66699C7.03993 1.66699 6.66683 2.04009 6.66683 2.50033V3.33366H4.16683V2.50033ZM2.50016 5.83366C2.50016 5.37342 2.87326 5.00033 3.3335 5.00033H7.50016C7.9604 5.00033 8.3335 5.37342 8.3335 5.83366V9.16699C8.3335 9.62723 7.9604 10.0003 7.50016 10.0003H3.3335C2.87326 10.0003 2.50016 9.62723 2.50016 9.16699V5.83366Z",
      fill: "#4D4D4D"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createVNode("path", {
      d: "M4.60225 17.6749L3.7094 13.5083C3.59823 12.9895 3.99369 12.5003 4.52423 12.5003C4.91718 12.5003 5.25673 12.7748 5.33907 13.1591L6.09077 16.667H15.5767L16.5168 12.2801L10.8823 10.8714C10.8504 10.8635 10.8171 10.8635 10.7852 10.8714C10.6083 10.9157 10.4597 10.7132 10.5353 10.5473C10.7269 10.1267 10.8336 9.6593 10.8336 9.16699C10.8336 9.13412 10.8603 9.10725 10.8931 9.10959C10.9317 9.11236 10.9702 9.11781 11.0082 9.12597L14.1669 9.80284V7.50033H11.6669C11.2067 7.50033 10.8336 7.12723 10.8336 6.66699C10.8336 6.20675 11.2067 5.83366 11.6669 5.83366V5.00033H11.1786C10.9137 5.00033 10.6854 4.8124 10.5847 4.56743C10.3814 4.0728 10.7053 3.33366 11.2401 3.33366H12.5003C12.9605 3.33366 13.3336 3.70675 13.3336 4.16699V5.83366H15.0003C15.4605 5.83366 15.8336 6.20675 15.8336 6.66699V10.3913L17.7025 10.8585C18.1384 10.9675 18.4094 11.4023 18.3153 11.8416L17.0653 17.6749C16.9829 18.0592 16.6434 18.3337 16.2504 18.3337H5.41709C5.02414 18.3337 4.68459 18.0592 4.60225 17.6749Z",
      fill: "#4D4D4D"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createVNode("path", {
      d: "M15.1639 12.9332L10.8338 12.0672L6.50366 12.9332C6.05236 13.0235 5.75968 13.4625 5.84994 13.9138C5.9402 14.3651 6.37922 14.6578 6.83052 14.5675L10.8338 13.7669L14.837 14.5675C15.2883 14.6578 15.7273 14.3651 15.8176 13.9138C15.9078 13.4625 15.6152 13.0235 15.1639 12.9332Z",
      fill: "#4D4D4D"
    })
  ])
], -1)
const _hoisted_9 = {
  key: 1,
  width: "21",
  height: "20",
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("g", { id: "ics_o_truck booking" }, [
  /*#__PURE__*/_createVNode("g", { id: "Vector" }, [
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12.1668 5.00035C11.7066 5.00033 11.3335 5.37343 11.3335 5.83368V15.0003H9.52385C9.40072 14.6521 9.20077 14.3321 8.9346 14.0659C8.46575 13.5971 7.82987 13.3337 7.16683 13.3337C6.50379 13.3337 5.8679 13.5971 5.39906 14.0659C5.13289 14.3321 4.93294 14.6521 4.80981 15.0003H4.66683V13.3337C4.66683 12.8734 4.29373 12.5003 3.8335 12.5003C3.37326 12.5003 3.00016 12.8734 3.00016 13.3337V15.0003C3.00016 15.4424 3.17576 15.8663 3.48832 16.1788C3.80088 16.4914 4.2248 16.667 4.66683 16.667H4.80981C4.93294 17.0152 5.13289 17.3353 5.39906 17.6014C5.8679 18.0703 6.50379 18.3337 7.16683 18.3337C7.82987 18.3337 8.46575 18.0703 8.9346 17.6014C9.20077 17.3353 9.40072 17.0152 9.52385 16.667H11.3335C11.6286 16.667 11.9156 16.5887 12.1668 16.4437C12.418 16.5887 12.7051 16.667 13.0002 16.667H13.1431C13.2663 17.0152 13.4662 17.3353 13.7324 17.6014C14.2012 18.0703 14.8371 18.3337 15.5002 18.3337C16.1632 18.3337 16.7991 18.0703 17.2679 17.6014C17.5341 17.3353 17.7341 17.0152 17.8572 16.667H18.0002C18.4422 16.667 18.8661 16.4914 19.1787 16.1788C19.4912 15.8663 19.6668 15.4424 19.6668 15.0003V11.1785C19.6667 10.7365 19.4911 10.3126 19.1785 10.0001L16.3336 7.15524C16.0211 6.84271 15.5971 6.66709 15.1552 6.66699H13.0002C13.0002 6.47917 13.0002 6.15006 13.0002 5.83363C13.0002 5.3734 12.6271 5.00036 12.1668 5.00035ZM13.1431 15.0003H13.0002V8.33366L15.1551 8.33375L18.0002 11.1788V15.0003H17.8572C17.7341 14.6521 17.5341 14.3321 17.2679 14.0659C16.7991 13.5971 16.1632 13.3337 15.5002 13.3337C14.8371 13.3337 14.2012 13.5971 13.7324 14.0659C13.4662 14.3321 13.2663 14.6521 13.1431 15.0003ZM6.57757 15.2444C6.73385 15.0881 6.94582 15.0003 7.16683 15.0003C7.38784 15.0003 7.5998 15.0881 7.75608 15.2444C7.91236 15.4007 8.00016 15.6126 8.00016 15.8337C8.00016 16.0547 7.91236 16.2666 7.75608 16.4229C7.5998 16.5792 7.38784 16.667 7.16683 16.667C6.94582 16.667 6.73385 16.5792 6.57757 16.4229C6.42129 16.2666 6.3335 16.0547 6.3335 15.8337C6.3335 15.6126 6.42129 15.4007 6.57757 15.2444ZM14.9109 15.2444C15.0672 15.0881 15.2791 15.0003 15.5002 15.0003C15.7212 15.0003 15.9331 15.0881 16.0894 15.2444C16.2457 15.4007 16.3335 15.6126 16.3335 15.8337C16.3335 16.0547 16.2457 16.2666 16.0894 16.4229C15.9331 16.5792 15.7212 16.667 15.5002 16.667C15.2791 16.667 15.0672 16.5792 14.9109 16.4229C14.7546 16.2666 14.6668 16.0547 14.6668 15.8337C14.6668 15.6126 14.7546 15.4007 14.9109 15.2444Z",
      fill: "#4D4D4D"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M3.8335 1.66699C4.29373 1.66699 4.66683 2.04009 4.66683 2.50033V3.33366H7.16683V2.50033C7.16683 2.04009 7.53993 1.66699 8.00016 1.66699C8.4604 1.66699 8.8335 2.04009 8.8335 2.50033V3.33366C8.8335 3.38076 8.82959 3.42694 8.82208 3.47191C9.79903 3.81186 10.5002 4.74088 10.5002 5.83366V9.16699C10.5002 10.5477 9.38087 11.667 8.00016 11.667H3.8335C2.45278 11.667 1.3335 10.5477 1.3335 9.16699V5.83366C1.3335 4.74088 2.03463 3.81186 3.01158 3.47191C3.00407 3.42694 3.00016 3.38076 3.00016 3.33366V2.50033C3.00016 2.04009 3.37326 1.66699 3.8335 1.66699ZM3.8335 5.00033C3.37326 5.00033 3.00016 5.37342 3.00016 5.83366V9.16699C3.00016 9.62723 3.37326 10.0003 3.8335 10.0003H8.00016C8.4604 10.0003 8.8335 9.62723 8.8335 9.16699V5.83366C8.8335 5.37342 8.4604 5.00033 8.00016 5.00033H3.8335ZM5.50016 7.50033C5.50016 7.04009 5.87326 6.66699 6.3335 6.66699H7.16683C7.62707 6.66699 8.00016 7.04009 8.00016 7.50033V8.33366C8.00016 8.7939 7.62707 9.16699 7.16683 9.16699H6.3335C5.87326 9.16699 5.50016 8.7939 5.50016 8.33366V7.50033Z",
      fill: "#4D4D4D"
    })
  ])
], -1)
const _hoisted_11 = {
  key: 2,
  width: "20",
  height: "20",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("g", { id: "Group 1972" }, [
  /*#__PURE__*/_createVNode("g", { id: "Vector" }, [
    /*#__PURE__*/_createVNode("path", {
      d: "M3.89746 12.2751C3.20089 12.3631 2.70551 13.0658 3.26567 13.4891C3.39064 13.5835 3.52896 13.6591 3.67531 13.7093L5.53665 14.3485L6.17576 16.2098C6.36248 16.7536 6.8163 17.1628 7.37647 17.2923C7.93664 17.4219 8.52404 17.2536 8.9306 16.8471L9.51986 16.2578C9.89378 15.8839 10.0681 15.3547 9.98954 14.8318L9.82287 13.7218L10.1767 13.368L11.4429 15.9345C11.6806 16.4164 12.136 16.7541 12.6662 16.8416C13.1963 16.9291 13.7361 16.7556 14.1161 16.3757L15.0589 15.4328C15.4495 15.0422 15.6212 14.4834 15.5173 13.9409L14.5669 8.9778L16.5351 7.00959C17.4841 6.06057 17.6916 4.3948 16.5909 3.29418C15.4903 2.19356 13.8245 2.40099 12.8755 3.35L11.2124 5.0314C10.9737 5.27267 10.8399 5.59833 10.8399 5.93768C10.8399 6.55597 11.2883 6.93451 11.8236 6.62516C12.0158 6.51411 12.1774 6.40426 12.2463 6.33536L14.054 4.52852C14.4453 4.13725 15.052 4.11232 15.4124 4.47269C15.7728 4.83307 15.7479 5.43982 15.3566 5.83108L13.0761 8.11155C12.8808 8.30685 12.795 8.58625 12.8469 8.85753L13.8804 14.2543L12.9375 15.1971L11.157 11.5879C10.9045 11.0761 10.2239 10.9638 9.82038 11.3673L8.34709 12.8406C8.16013 13.0275 8.07299 13.2921 8.11225 13.5536L8.34135 15.0793L7.75209 15.6685L6.84841 13.0367L4.43317 12.3189C4.25957 12.2673 4.07714 12.2524 3.89746 12.2751Z",
      fill: "#4D4D4D"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M3.1665 0.666992C3.62674 0.666992 3.99984 1.04009 3.99984 1.50033V2.33366H6.49984V1.50033C6.49984 1.04009 6.87293 0.666992 7.33317 0.666992C7.79341 0.666992 8.1665 1.04009 8.1665 1.50033V2.33366C8.1665 2.38076 8.1626 2.42694 8.15509 2.47191C9.13204 2.81186 9.83317 3.74088 9.83317 4.83366V8.16699C9.83317 9.5477 8.71388 10.667 7.33317 10.667H3.1665C1.78579 10.667 0.666504 9.5477 0.666504 8.16699V4.83366C0.666504 3.74088 1.36763 2.81186 2.34459 2.47191C2.33708 2.42694 2.33317 2.38076 2.33317 2.33366V1.50033C2.33317 1.04009 2.70627 0.666992 3.1665 0.666992ZM3.1665 4.00033C2.70627 4.00033 2.33317 4.37342 2.33317 4.83366V8.16699C2.33317 8.62723 2.70627 9.00033 3.1665 9.00033H7.33317C7.79341 9.00033 8.1665 8.62723 8.1665 8.16699V4.83366C8.1665 4.37342 7.79341 4.00033 7.33317 4.00033H3.1665ZM4.83317 6.50033C4.83317 6.04009 5.20627 5.66699 5.6665 5.66699H6.49984C6.96007 5.66699 7.33317 6.04009 7.33317 6.50033V7.33366C7.33317 7.7939 6.96007 8.16699 6.49984 8.16699H5.6665C5.20627 8.16699 4.83317 7.7939 4.83317 7.33366V6.50033Z",
      fill: "#4D4D4D"
    })
  ])
], -1)
const _hoisted_13 = {
  key: 3,
  class: "ml-1 bg-red-lp-600 rounded text-center text-red-lp-1600 font-medium text-xs px-1"
}
const _hoisted_14 = {
  key: 4,
  class: "bg-yellow-lp-200 rounded text-center text-yellow-lp-100 font-medium text-xs px-1"
}
const _hoisted_15 = { key: 5 }
const _hoisted_16 = {
  key: 0,
  class: "bg-yellow-lp-200 px-2 rounded-xl text-14px text-yellow-lp-100 mt-2 ml-5 inline-flex"
}
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "pt-0.5 pr-1" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "16",
    height: "17",
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M8.0001 3.83325C7.07712 3.83325 6.17487 4.10695 5.40744 4.61973C4.64001 5.13251 4.04187 5.86134 3.68866 6.71406C3.33545 7.56678 3.24304 8.5051 3.4231 9.41034C3.60316 10.3156 4.04762 11.1471 4.70027 11.7998C5.35291 12.4524 6.18443 12.8969 7.08968 13.0769C7.99492 13.257 8.93323 13.1646 9.78595 12.8114C10.6387 12.4581 11.3675 11.86 11.8803 11.0926C12.3931 10.3252 12.6668 9.4229 12.6668 8.49992C12.6668 7.26224 12.1751 6.07526 11.2999 5.20009C10.4248 4.32492 9.23777 3.83325 8.0001 3.83325ZM7.33343 2.49992V2.53707C7.1649 2.55591 6.99679 2.58194 6.82956 2.61521C5.66567 2.84672 4.59657 3.41816 3.75746 4.25728C2.91834 5.09639 2.3469 6.16549 2.11539 7.32938C1.88388 8.49326 2.0027 9.69966 2.45682 10.796C2.91095 11.8924 3.67998 12.8294 4.66668 13.4887C5.65337 14.148 6.81341 14.4999 8.0001 14.4999C9.5914 14.4999 11.1175 13.8678 12.2427 12.7426C13.368 11.6173 14.0001 10.0912 14.0001 8.49992C14.0001 7.31323 13.6482 6.15319 12.9889 5.1665C12.3296 4.1798 11.3926 3.41077 10.2962 2.95664C9.77261 2.73977 9.22393 2.59936 8.66676 2.53707V2.49992C8.66676 2.32311 8.59653 2.15354 8.4715 2.02851C8.34648 1.90349 8.17691 1.83325 8.0001 1.83325C7.82329 1.83325 7.65372 1.90349 7.52869 2.02851C7.40367 2.15354 7.33343 2.32311 7.33343 2.49992ZM10.6668 9.49992H8.0001C7.82329 9.49992 7.65372 9.42968 7.52869 9.30466C7.40367 9.17963 7.33343 9.01006 7.33343 8.83325V5.83325C7.33343 5.65644 7.40367 5.48687 7.52869 5.36185C7.65372 5.23682 7.82329 5.16659 8.0001 5.16659C8.17691 5.16659 8.34648 5.23682 8.4715 5.36185C8.59653 5.48687 8.66676 5.65644 8.66676 5.83325V8.16659H10.6668C10.8436 8.16659 11.0131 8.23682 11.1382 8.36185C11.2632 8.48687 11.3334 8.65644 11.3334 8.83325C11.3334 9.01006 11.2632 9.17963 11.1382 9.30466C11.0131 9.42968 10.8436 9.49992 10.6668 9.49992ZM1.63343 5.05325C1.74079 5.12845 1.86903 5.16808 2.0001 5.16659C2.1099 5.16602 2.21787 5.13834 2.3144 5.086C2.41093 5.03366 2.49304 4.95829 2.55343 4.86659C2.83869 4.43149 3.20543 4.0557 3.63343 3.75992C3.77766 3.67313 3.88373 3.53499 3.93033 3.37324C3.97692 3.21149 3.96061 3.0381 3.88465 2.88788C3.8087 2.73766 3.67873 2.62173 3.52084 2.56337C3.36295 2.50501 3.18883 2.50854 3.03343 2.57325C2.39752 2.97184 1.85607 3.50418 1.44677 4.13325C1.35028 4.28023 1.31576 4.45937 1.35072 4.63168C1.38568 4.80398 1.48729 4.9555 1.63343 5.05325ZM14.0001 5.16659C13.8909 5.16675 13.7833 5.14009 13.6868 5.08894C13.5904 5.03779 13.5079 4.96373 13.4468 4.87325C13.1648 4.43369 12.7976 4.05511 12.3668 3.75992C12.2225 3.67313 12.1165 3.53499 12.0699 3.37324C12.0233 3.21149 12.0396 3.0381 12.1155 2.88788C12.1915 2.73766 12.3215 2.62173 12.4794 2.56337C12.6372 2.50501 12.8114 2.50854 12.9668 2.57325C13.6027 2.97184 14.1441 3.50418 14.5534 4.13325C14.6506 4.27942 14.6861 4.458 14.6524 4.63023C14.6187 4.80247 14.5185 4.95447 14.3734 5.05325C14.2619 5.12499 14.1327 5.16424 14.0001 5.16659Z",
      fill: "#F09035"
    })
  ])
], -1)
const _hoisted_18 = { class: "flex flex-col gap-1 text-gray-lp-300 text-sm" }
const _hoisted_19 = { class: "font-bold" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_21 = { key: 0 }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_23 = { class: "hidden" }
const _hoisted_24 = { class: "hidden" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_CargoFilterSection = _resolveComponent("CargoFilterSection")!
  const _component_CargoDispute = _resolveComponent("CargoDispute")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_Print = _resolveComponent("Print")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_WidgetDownloadCargo = _resolveComponent("WidgetDownloadCargo")!
  const _directive_tooltip = _resolveDirective("tooltip")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_CargoFilterSection, {
          ref: "filterSection",
          onOnChangeFilter: _ctx.onHandleFilter,
          "booking-type": "success"
        }, null, 8, ["onOnChangeFilter"]),
        _createVNode(_component_CargoDispute),
        (_ctx.cargoListAvailable)
          ? (_openBlock(), _createBlock(_component_EmptyState, {
              key: 0,
              customMessage: _ctx.$t('Oops.. Belum ada data yang dapat ditampilkan')
            }, null, 8, ["customMessage"]))
          : (_openBlock(), _createBlock("div", _hoisted_3, [
              _createVNode(_component_TableV2, {
                columns: _ctx.columns,
                data: _ctx.cargoList,
                loading: _ctx.isLoading,
                pagination: _ctx.pagination,
                "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pagination = $event)),
                totalColumnFreeze: 1,
                paginationStyle: "v3",
                isRightFreeze: "",
                onRequest: _ctx.fetchCargoList,
                errorCause: _ctx.errorCause,
                isDetailAble: _ctx.ableToViewDetail,
                onClick: _ctx.onClickRow,
                groupAction: true,
                groupOptions: _ctx.actionGroupOptions,
                isSpaceTop: false,
                bgHeader: "bg-white border-b border-gray-lp-200",
                paginationV3PaddingVertical: "py-2",
                pinnedSubstractHeight: "400px",
                isPinnedScrollBottom: "",
                customClassPagination: 'absolute w-full bottom-4 right-0 left-0 -mb-4 px-8',
                paginationWidth: "cargo-tab-booking-success-pagination",
                isNoPaddingBottom: "",
                isTabList: false
              }, {
                number_cargo: _withId(({item}) => [
                  _createVNode("div", _hoisted_4, [
                    _createVNode("div", _hoisted_5, [
                      _createVNode("div", _hoisted_6, [
                        (item.cargoType === 'ship')
                          ? (_openBlock(), _createBlock("svg", _hoisted_7, [
                              _hoisted_8
                            ]))
                          : (item.cargoType === 'truck')
                            ? (_openBlock(), _createBlock("svg", _hoisted_9, [
                                _hoisted_10
                              ]))
                            : (item.cargoType === 'plane')
                              ? (_openBlock(), _createBlock("svg", _hoisted_11, [
                                  _hoisted_12
                                ]))
                              : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(_ctx.ellipsisString(item.cargoNumber, 40)) + " ", 1),
                        (item.cargoType === 'plane' && item.cargoCommodityGroupIsDg)
                          ? (_openBlock(), _createBlock("span", _hoisted_13, " DG "))
                          : _createCommentVNode("", true),
                        (item.cargoType === 'plane' && item.cargoCommodityGroupIsQuarantine)
                          ? (_openBlock(), _createBlock("span", _hoisted_14, " K "))
                          : _createCommentVNode("", true),
                        (item.isDisputeCargo)
                          ? (_openBlock(), _createBlock("div", _hoisted_15, [
                              _withDirectives(_createVNode("div", null, [
                                _createVNode(_component_Icons, {
                                  name: "kg-dispute",
                                  class: "w-5 text-red-lp-100"
                                })
                              ], 512), [
                                [
                                  _directive_tooltip,
                                  'Kargo dengan selisih berat',
                                  void 0,
                                  { bottom: true }
                                ]
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (
                  _ctx.showRemainingTimePlane(
                    _ctx.CalculateTimeDifference(_ctx.DateNow, item.estimationDepartureDate),
                    item.cargoType,
                    item.departureTime
                  )
                )
                        ? (_openBlock(), _createBlock("div", _hoisted_16, [
                            _hoisted_17,
                            _createTextVNode(" " + _toDisplayString(_ctx.CalculateTimeDifference(_ctx.DateNow, item.estimationDepartureDate)), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                origin_destination: _withId(({item}) => [
                  _createVNode("div", _hoisted_18, [
                    _createVNode("div", _hoisted_19, [
                      _withDirectives(_createVNode("span", null, [
                        _createTextVNode(_toDisplayString(item.originCityCode), 1)
                      ], 512), [
                        [
                          _directive_tooltip,
                          item.originCityName,
                          void 0,
                          { bottom: true }
                        ]
                      ]),
                      _hoisted_20,
                      _withDirectives(_createVNode("span", null, [
                        _createTextVNode(_toDisplayString(item.destinationCityCode), 1)
                      ], 512), [
                        [
                          _directive_tooltip,
                          item.destinationCityName,
                          void 0,
                          { bottom: true }
                        ]
                      ])
                    ]),
                    (item.cargoType === 'plane')
                      ? (_openBlock(), _createBlock("div", _hoisted_21, [
                          _withDirectives(_createVNode("span", null, [
                            _createTextVNode(_toDisplayString(item.airportOriginCityCode), 1)
                          ], 512), [
                            [
                              _directive_tooltip,
                              item.airportOriginCityName,
                              void 0,
                              { bottom: true }
                            ]
                          ]),
                          _hoisted_22,
                          _withDirectives(_createVNode("span", null, [
                            _createTextVNode(_toDisplayString(item.airportDestinationCityCode), 1)
                          ], 512), [
                            [
                              _directive_tooltip,
                              item.airportDestinationCityName,
                              void 0,
                              { bottom: true }
                            ]
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }, 8, ["columns", "data", "loading", "pagination", "onRequest", "errorCause", "isDetailAble", "onClick", "groupOptions"])
            ]))
      ])
    ]),
    _withDirectives(_createVNode("div", _hoisted_23, null, 512), [
      [_directive_click_outside, () => (_ctx.chevronUp = _ctx.chevronUp.map(() => false))]
    ]),
    _createVNode("div", _hoisted_24, [
      _createVNode(_component_Print, { ref: "print" }, null, 512)
    ]),
    (_ctx.isErrorPrint && !_ctx.isLoadingPrint)
      ? (_openBlock(), _createBlock(_component_ErrorMessage, {
          key: 0,
          errorType: _ctx.errorCause,
          onCancel: _ctx.closeModalErrorPrintList,
          onTryAgain: () => _ctx.refs.print.printManifest(_ctx.cargoNumber),
          modal: ""
        }, null, 8, ["errorType", "onCancel", "onTryAgain"]))
      : _createCommentVNode("", true),
    _createVNode(_component_WidgetDownloadCargo)
  ], 64))
})